'use client';

import { c as _c } from "react/compiler-runtime";
import { BillingPeriodSelector } from '../billing-period-selector/billing-period-selector';
import { FacetSelectionSection } from '../facet-selection-section';
import { PricingCalculator } from '../service-catalog';
function ConfigureServices() {
  const $ = _c(3);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <FacetSelectionSection />;
    t1 = <BillingPeriodSelector />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="mt-6 flex flex-col gap-6">{t0}{t1}<div className="flex w-full flex-col gap-6 lg:flex-row lg:items-start"><PricingCalculator /></div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
export { ConfigureServices };